module.exports = __webpack_public_path__ + "static/media/301.9aae9b5a.jpg";